module.exports = __webpack_public_path__ + "img/cmp-clock.2ac5e138.svg";